// The shippers with orders on the plan board. Shared by the Customize Pins shipper grouping and
// the Orders filter, which would otherwise derive "the board's shippers" twice and drift.

// Partnerships carry the dispatcher's own alias for a shipper, but they are not the roster: an
// order can arrive from any shipper -- a claimed marketplace load, or an order routed to this
// carrier with no partnership row. The id is the last resort, since OrderRouteFields carries
// order_shipper on every planning order, so an unpartnered shipper still reads as a name.
//
// Board order, not sorted: the shape pool hands out pins by iteration order, so sorting here
// would reassign them. The filter sorts its own dropdown.
export const getBoardShippers = ({ orders, shipping_partners, user_id } = {}) => {
    const partnersByShipperId = Object.fromEntries(
        (shipping_partners || []).filter((p) => p?.shipper_id).map((p) => [p.shipper_id, p])
    );

    const byId = new Map();
    (orders || []).forEach((order) => {
        const shipper_id = order?.shipper_id;
        // The client's own orders are not a shipper: this is the counterparty, which is also how
        // useShapeFieldTypeOptions decides whether to offer the grouping at all.
        if (!shipper_id || shipper_id === user_id || byId.has(shipper_id)) return;
        const partner = partnersByShipperId[shipper_id];
        byId.set(shipper_id, {
            shipper_id,
            label:
                partner?.shipper_alias ||
                partner?.shipper?.business_name ||
                order.order_shipper?.business_name ||
                shipper_id,
        });
    });

    return [...byId.values()];
};

// The same shippers in the shape ORDER_FILTER_OPTIONS uses, so a category whose options come from
// the data goes through the filter pipeline and the dropdowns exactly like the static ones.
export const getShipperFilterOptions = (args) => ({
    ALL: { label: 'All', predicate: null },
    ...Object.fromEntries(
        getBoardShippers(args)
            .sort((a, b) => String(a.label).localeCompare(String(b.label)))
            .map(({ shipper_id, label }) => [
                shipper_id,
                { label, predicate: (order) => order.shipper_id === shipper_id },
            ])
    ),
});
